import { FiCheck, FiRefreshCw, FiCloudOff } from 'react-icons/fi';
import { useTestSession } from '../hooks/useTestSession';

export function SessionSyncStatus() {
  const { pendingSyncCount, isSyncing, syncNow } = useTestSession();
  const count = pendingSyncCount;

  if (count === 0 && !isSyncing) {
    return (
      <div>
        <FiCheck />
        <span>All Saved</span>
      </div>
    );
  }

  return (
    <div>
      <div>
        {isSyncing ? <FiRefreshCw /> : <FiCloudOff />}
        <span>
          {isSyncing ? 'Syncing...' : `${count} Unsaved`}
        </span>
      </div>

      {!isSyncing && count > 0 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            syncNow();
          }}
        >
          Sync Now
        </button>
      )}
    </div>
  );
}
